/**
 * Configuração do cliente.
 *
 * Só entra aqui o que é PÚBLICO por construção. Nenhum segredo do Cosmos
 * atravessa esta fronteira — quem os guarda é a Pages Function.
 */

/**
 * Site key do Turnstile.
 *
 * É pública por desenho: fica no HTML de qualquer visitante. O que não pode
 * vazar é a Secret Key, que vive na Function como segredo do ambiente.
 *
 * Sobrescrevível por `VITE_TURNSTILE_SITEKEY` para apontar um widget de teste
 * em desenvolvimento sem editar o código.
 */
export const TURNSTILE_SITEKEY =
  import.meta.env.VITE_TURNSTILE_SITEKEY ?? '0x4AAAAAAEPhPGSq4GWEJQcu'

/**
 * Ação do Turnstile na abertura do pré-cadastro.
 *
 * PRECISA ser idêntica ao `turnstileAcao` da rota `iniciar` em
 * `functions/_lib/rotas.ts`. O servidor recusa token cuja ação não bata — é o
 * que impede um token obtido em outro formulário ser gasto aqui.
 */
export const ACAO_INICIAR = 'precadastro-iniciar'

/**
 * Ação do Turnstile no acompanhamento.
 *
 * SEPARADA da abertura de propósito, e não é formalidade: um token emitido no
 * formulário de cadastro não pode ser gasto para pedir código de acesso a um
 * CNPJ alheio. É o par desta constante com o `turnstileAcao` da rota
 * `solicitarAcesso` que o servidor confere.
 */
export const ACAO_ACESSO = 'precadastro-acesso'

/** Base das chamadas ao proxy. Mesma origem: sem CORS, sem preflight. */
export const BASE_API = '/api'
